export const defaultView =
{
    "count_diners": 3,
    "count_order_line_items": 3,
    "received_at": "2019-01-28T21:52:05.315Z",
    "count_diner_line_items": {
      "fToAWsCwTpyWPQYbDfusyA": 2,
      "WXDJoFvMEeiy2LGoPGssuQ": 1,
      "LB5o0JvzROGFQK_51CB_mQ": 1
    },
    "count_diner_special_instruction": {
        "fToAWsCwTpyWPQYbDfusyA": 2,
        "WXDJoFvMEeiy2LGoPGssuQ": 1,
        "LB5o0JvzROGFQK_51CB_mQ": 1
    },
    "aggregated_delivery_fee": 300,
    "aggregated_grand_total": 5555,
    "aggregated_adjusted_total": 3333
};

export const newDefaultOrderView =
  {
    "count_diners": 1,
    "count_order_line_items": 2,
    "count_order_line_items_special_instructions": 2,
    "count_diner_line_items": {},
    "count_diner_special_instruction": {},
    "aggregated_delivery_fee": 300,
    "aggregated_grand_total": 5555,
    "aggregated_adjusted_total": 3333
  };

export const cateringOrderView =
{
  ...defaultView,
  "count_order_line_items_special_instructions": 2
}
export const oneItemView =
  {
    "count_diners": 3,
    "count_order_line_items": 1,
    "received_at": "2019-01-28T21:52:05.315Z",
    "count_diner_line_items": {
      "fToAWsCwTpyWPQYbDfusyA": 1,
      "WXDJoFvMEeiy2LGoPGssuQ": 1,
      "LB5o0JvzROGFQK_51CB_mQ": 1
    },
    "count_diner_special_instruction": {},
    "aggregated_delivery_fee": 300,
    "aggregated_grand_total": 5555,
    "aggregated_adjusted_total": 3333
  };

export const sgoGhdOrderView =
  {
    "count_diners": 1,
    "count_order_line_items": 4,
    "count_order_line_items_special_instructions": 2,
    "count_diner_line_items": {
      "x2B3UEeCEeqY2M8BfdZe-w": 4
    },
    "count_diner_special_instruction": {},
    "aggregated_delivery_fee": 300,
    "aggregated_grand_total": 2323,
    "aggregated_adjusted_total": 3333
  };



// WEBPACK FOOTER //
// ./client/app/util/mock_views.js